import gql from "graphql-tag";
import {LiveFlightFragment} from "../../../Queries/LiveFlights";

export default gql`
    query GetFlights(
        $filter: FlightsFilterInput
        $bookmark: String
        $limit: Int
    ){
        flights(
            filter: $filter
            limit: $limit
            bookmark: $bookmark
        ) {
            bookmark
            docs {
                ...LiveFlightFragment
            }
        }
    }
    ${LiveFlightFragment}
`